import { LastMessageText } from '@halo/ui-chat-react';
import type { Msg } from '@halo/chat-sdk-react';
import { Box } from '@chakra-ui/react';
import { Emoji } from '@/components/Emoji';
import { MsgForwardIcon } from '../../msg-parts';
import { MsgFilePreviewContent } from './msg-file-preview-content';

export interface MsgFilePreviewProps {
  message: Msg;
}

export const MsgFilePreview = memo(function MsgFilePreview({ message }: MsgFilePreviewProps) {
  return (
    <LastMessageText>
      <Emoji.MessagePrefix reactions={message.emoji_reaction} />
      <MsgForwardIcon message={message} />
      <Box flex="1" minW="0" truncate>
        <MsgFilePreviewContent message={message} />
      </Box>
    </LastMessageText>
  );
});
